"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const format_1 = __importDefault(require("date-fns/format"));
const get_1 = __importDefault(require("lodash/get"));
const DEFAULT_CURRENCY_1 = __importDefault(require("../../../constants/date/DEFAULT_CURRENCY"));
const PAYMENT_TYPE_1 = __importDefault(require("../../../constants/payment/PAYMENT_TYPE"));
const getLocalTimeStampFromGMT_1 = __importDefault(require("../../../utils/store/getLocalTimeStampFromGMT"));
const branchFactory_1 = __importDefault(require("../../branch/branchFactory"));
const fleetGroupFactory_1 = __importDefault(require("../../fleetgroup/fleetGroupFactory"));
const getBookingStatus_1 = __importDefault(require("../../utils/booking/getBookingStatus"));
const bookingPriceFactory_1 = __importDefault(require("../bookingPriceFactory"));
// comment.
/**
 * Returns formatted my bookings list data
 * @param {BookingDetailsResponseType} booking
 * @param {LANG_VALUES} language
 * @returns {BookingListType}
 */
function bookingListFactory(booking, language) {
    const rawBookingPrice = (0, get_1.default)(booking, 'bookingPrice', {});
    const soldDays = (0, get_1.default)(booking, 'soldDays', '');
    const currency = (0, get_1.default)(booking, 'currency', DEFAULT_CURRENCY_1.default);
    const bookingDateTime = (0, get_1.default)(booking, 'bookingDateTime', Date.now() / 1000);
    const dropOffDateTime = (0, get_1.default)(booking, 'dropOffDateTime', Date.now() / 1000);
    const pickupDateTime = (0, get_1.default)(booking, 'pickupDateTime', Date.now() / 1000);
    const rawPickupBranch = (0, get_1.default)(booking, 'pickupBranch', {});
    const rawDropoffBranch = (0, get_1.default)(booking, 'dropOffBranch', {});
    const rawVehicleDetails = (0, get_1.default)(booking, 'vehicleGroup', {});
    const bookingStatus = (0, get_1.default)(booking, 'status', '');
    const isCancellable = (0, get_1.default)(booking, 'cancellable');
    // find payment type
    const paymentType = (0, get_1.default)(booking, 'paymentType', '');
    const isPayAtBranch = paymentType === PAYMENT_TYPE_1.default.PAY_AT_BRANCH;
    const isPayByCard = paymentType === PAYMENT_TYPE_1.default.CHECKOUT;
    // in local KSA time
    const localBookingTimeStamp = (0, getLocalTimeStampFromGMT_1.default)(bookingDateTime);
    const localDropOffTimeStamp = (0, getLocalTimeStampFromGMT_1.default)(dropOffDateTime);
    const localPickUpTimeStamp = (0, getLocalTimeStampFromGMT_1.default)(pickupDateTime);
    const agreementStatus = (0, get_1.default)(booking, 'agreementDetails.status', '');
    const referenceNo = (0, get_1.default)(booking, 'referenceNo', '');
    return {
        referenceNo,
        displayId: (0, get_1.default)(booking, 'displayId', ''),
        status: bookingStatus,
        agreementDetails: (0, get_1.default)(booking, 'agreementDetails', null),
        bookingDate: (0, format_1.default)(localBookingTimeStamp, 'dd MMMM'),
        bookingTime: (0, format_1.default)(localBookingTimeStamp, 'hh:mm a'),
        dropOffDateTime,
        dropOffDate: (0, format_1.default)(localDropOffTimeStamp, 'dd MMMM'),
        dropOffTime: (0, format_1.default)(localDropOffTimeStamp, 'hh:mm a'),
        pickupDateTime,
        pickupDate: (0, format_1.default)(localPickUpTimeStamp, 'dd MMMM'),
        pickupTime: (0, format_1.default)(localPickUpTimeStamp, 'hh:mm a'),
        priceDetails: (0, bookingPriceFactory_1.default)(rawBookingPrice, soldDays, currency),
        pickupBranch: (0, branchFactory_1.default)(rawPickupBranch, language),
        dropOffBranch: (0, branchFactory_1.default)(rawDropoffBranch, language),
        currency,
        vehicleDetails: (0, fleetGroupFactory_1.default)(rawVehicleDetails, language),
        bookingType: (0, getBookingStatus_1.default)(referenceNo, pickupDateTime, dropOffDateTime, bookingStatus, agreementStatus),
        paymentType,
        isPayAtBranch,
        isPayByCard,
        isCancellable,
    };
}
exports.default = bookingListFactory;
